import { logger } from '@/lib/logger';

// Must match the `passtype` path segment the backend recognizes — NOT an enum
// name. The backend rejects anything else (e.g. `APPLE_PASS`) with 400.
const APPLE_PASS_TYPE = 'ApplePass';

function buildApiUrl(path: string, params: Record<string, string>): string {
  const base = process.env.NEXT_PUBLIC_API_URL ?? '';
  if (!base) {
    logger.error('Apple Wallet pass: NEXT_PUBLIC_API_URL is not set', undefined, {
      feature: 'wallet-pass',
      route: path,
    });
    return '';
  }
  const url = new URL(path, base.endsWith('/') ? base : `${base}/`);
  url.search = new URLSearchParams(params).toString();
  return url.toString();
}

// These URLs must be navigated to, never fetched into a blob: the response's
// pkpass Content-Type + Content-Disposition are what open the OS Wallet sheet,
// and a blob: URL discards both. `token` keeps its "Bearer " prefix because
// AuthenticationServiceImpl.validateAndGetUserId branches on it.
export function buildLoyaltyApplePassUrl(token: string, domain: string): string {
  if (!token || !domain) return '';
  return buildApiUrl(`pass/loyalty/create/${APPLE_PASS_TYPE}`, { domain, token });
}

export function buildReservationApplePassUrl(
  company: string,
  reservationId: string
): string {
  if (!company || !reservationId) return '';
  return buildApiUrl(
    `pass/reservation/${encodeURIComponent(company)}/create/${APPLE_PASS_TYPE}`,
    { reservationId }
  );
}
